// Synthèse vocale française (Web Speech API). Activable dans les réglages.
// Aucune API payante. Fonctionne uniquement dans les navigateurs le prenant en charge.

let enabled = false;
let voice = null;
let voicesLoaded = false;

export function isTtsSupported() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

function pickFrenchVoice() {
  if (!isTtsSupported()) return null;
  const voices = window.speechSynthesis.getVoices();
  if (!voices || !voices.length) return null;
  // Préfère une voix française féminine douce, sinon toute voix fr-*
  const prefer = [
    /Amelie|Aurélie|Marie|Julie|Léa|Audrey/i,
    /fr-FR/i,
    /fr[-_]/i,
    /French/i,
  ];
  for (const re of prefer) {
    const found = voices.find(v => re.test(v.name) || re.test(v.lang));
    if (found) return found;
  }
  return voices[0] || null;
}

export function initTts() {
  if (!isTtsSupported()) return;
  const load = () => {
    voice = pickFrenchVoice();
    voicesLoaded = true;
  };
  load();
  window.speechSynthesis.onvoiceschanged = load;
}

export function setTtsEnabled(v) {
  enabled = !!v;
  if (!enabled && isTtsSupported()) {
    try { window.speechSynthesis.cancel(); } catch (e) { /* ignore */ }
  }
}

export function isTtsEnabled() { return enabled; }
export function hasFrenchVoice() { return !!voice && /fr/i.test(voice.lang || ""); }

export function speak(text) {
  if (!enabled || !isTtsSupported() || !text) return;
  try {
    if (!voice && !voicesLoaded) voice = pickFrenchVoice();
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    if (voice) u.voice = voice;
    u.lang = voice?.lang || "fr-FR";
    u.rate = 0.85;
    u.pitch = 1.0;
    u.volume = 0.9;
    window.speechSynthesis.speak(u);
  } catch (e) { /* ignore */ }
}

export function stopSpeaking() {
  if (!isTtsSupported()) return;
  try { window.speechSynthesis.cancel(); } catch (e) { /* ignore */ }
}
